import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/bookmarks/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_LAST_LOADED_TIMESTAMP = NAMESPACE + 'SET_LAST_LOADED_TIMESTAMP'
export const ADD = NAMESPACE + 'ADD'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = {
  ids: [],
  byId: {},
  isLoading: false,
  isLoaded: false,
  lastLoadedTimestamp: null
}

const bookmarkDefaults = {
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case SET_LAST_LOADED_TIMESTAMP:
      return {
        ...state,
        lastLoadedTimestamp: action.payload.lastLoadedTimestamp
      }
    case ADD:
      return {
        ...state,
        ids: addUniqueValueToArray({
          array: state.ids,
          value: action.payload.id,
          index: action.payload.index
        }),
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...bookmarkDefaults,
            ...state.byId[action.payload.id],
            ...action.payload
          }
        }
      }
    case REMOVE: {
      const newState = {
        ...state,
        ids: [ ...state.ids.filter(id => id !== action.payload.id) ],
        byId: { ...state.byId }
      }
      delete newState.byId[action.payload.id]
      return newState
    }
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function setLastLoadedTimestamp (lastLoadedTimestamp) {
  return {
    type: SET_LAST_LOADED_TIMESTAMP,
    payload: {
      lastLoadedTimestamp
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function remove (id) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}
